const info = {
  state: {
    memberType: {type: 'player'},
    registerInfo: {}
  },
  mutations: {
    setMemberType(state, type) {
      state.memberType = type
    },
    setRegisterInfo(state, info) {
      state.registerInfo = Object.assign(info, state.registerInfo)
    }
  },
  actions: {
    setMemberType(context, type) {
      context.commit('setMemberType', type)
    },
    setRegisterInfo(context, info) {
      context.commit('setRegisterInfo', info)
    }
  }
}

export default info



// WEBPACK FOOTER //
// ./src/store/modules/info.js